<script lang="ts">
  import { Jumper } from "svelte-loading-spinners";

  import { onMount } from "svelte";
  import { createEventDispatcher } from "svelte";
  import { fade } from "svelte/transition";
  import vhCheck from "vh-check";
  // import Button from "mtb_svelte/components/tailwind/Button.svelte";
  // import Slider from "mtb_svelte/components/tailwind/Slider.svelte";
  // import Widget from "mtb_svelte/components/Widget.svelte";
  // import ButtonGroup from "mtb_svelte/components/tailwind/ButtonGroup.svelte";
  // import pannable from "mtb_svelte/lib/actions/pannable";

  const dispatch = createEventDispatcher();

  export let src = "";
  export let src_mobile = "";
  export let title = "";
  export let description = "";
  export let subtitle = "";
  export let sync = false;
  export let flip = false;
  export let color_invert = true;

  export let duration = undefined;
  export let currentTime = undefined;
  export let video: HTMLVideoElement;

  export let frameRate = 30;

  let show_description = false;
  let loaded = false;
  let cv: HTMLCanvasElement;

  export let blur = false;

  let width;
  let height;
  let on_mobile =
    typeof window.orientation !== "undefined" ||
    navigator.userAgent.indexOf("IEMobile") !== -1;
  let loop_playing = false;
  // requestAnimationFrame() shim
  window.requestAnimFrame = (function () {
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (/* function */ callback, /* DOMElement */ element) {
        window.setTimeout(callback, 1000 / 24);
      }
    );
  })();
  // export let fill_vertical = false;
  // let video_playing = true;
  $: {
    if (cv) {
      if (flip) {
        let ctx = cv.getContext("2d");
        if (ctx) {
          ctx.translate(cv.width, 0);
          ctx.scale(-1, 1);
        }
      } else {
        let ctx = cv.getContext("2d");
        if (ctx) {
          ctx.translate(cv.width, 0);
          ctx.scale(-1, 1);
        }
      }
    }
  }

  function update_gl() {
    window.requestAnimFrame(update_gl);
    // let split_amount = 1 - split_amounte;
    var ctx = cv.getContext("2d");
    if (!ctx) return;
    // if (flip) {
    //   ctx.translate(cv.width, 0);
    //   ctx.scale(-1, 1);
    // }

    ctx.filter = `blur(${blur ? 12 : 0}px) invert(${color_invert ? 100 : 0}%)`;

    // const target_height = cv.height;
    // const target_width = cv.width;

    // const oneW = video.videoWidth / 2;
    // const cutpoint = target_width - target_width * (1 - split_amount);

    // if (fill_vertical) {
    //   // fill vertically
    //   var vRatio = (target_height / source_height)// * oneW;
    //   ctx.drawImage(video, 0, 0, vRatio, target_height);
    // } else {
    // ctx.clearRect(0, 0, cv.width, cv.height);
    var scale = Math.min(
      cv.width / video.videoWidth,
      cv.height / video.videoHeight
    );
    // get the top left position of the image
    var x = cv.width / 2 - (video.videoWidth / 2) * scale;
    var y = cv.height / 2 - (video.videoHeight / 2) * scale;

    ctx.rect(0, 0, cv.width, cv.height);
    ctx.fill();
    ctx.drawImage(
      video,
      x,
      y,
      video.videoWidth * scale,
      video.videoHeight * scale
    );

    // //BEFORE
    // ctx.drawImage(
    //   video,
    //   0,
    //   0,
    //   video.videoWidth,
    //   video.videoHeight,
    //   0,
    //   0,
    //   cv.width,
    //   cv.height
    // );
    // }
  }

  const loop = () => {
    if (video) {
      // window.requestAnimFrame(loop);
      if (!video.paused && !video.ended) {
        update_gl();
        // update_gl(); // calling it twice sync up the video for some reason.
        // drawing at 30fps
        // setTimeout(loop, 1000 / frameRate); // drawing at 30fps
      }
    } else {
      console.log("-NO VIDEO-");
    }
  };
  function on_loaded() {
    dispatch("loaded", {
      value: true,
      canvas: cv,
      video: video,
    });
    loaded = true;
    video.addEventListener("play", loop);
    // if (!on_mobile) {
    //   video.play();
    //   loop_playing = true;
    // }
    video.removeEventListener("canplaythrough", on_loaded);
    if (sync) {
      video.addEventListener("timeupdate", function () {
        // if (this.currentTime >= this.duration - 0.3) {
        //   dispatch("restarted", {});
        // }
        if (this.currentTime >= 0.1) {
          dispatch("restarted", {});
        }
      });
    }
  }

  onMount(() => {
    //var ctx = cv.getContext("2d");
    vhCheck();
    video.addEventListener("canplaythrough", on_loaded);
  });
  // video.addEventListener("loadedmetadata", function () {
  //   // cv.width = video.videoWidth;
  //   // cv.height = video.videoHeight;
  //   dispatch('loaded', {
  //     value: true,
  //     canvas: cv,
  //     video: video
  //   });
  //   loaded = true;
  //   video.addEventListener("play", loop);
  //   video.play();
  // });

  // cv.ondragstart = function () {
  //   return false;
  // };

  // $: if (cv) {
  //   update_gl();
  // }

  function handleMouseOver(e) {
    show_description = true;
    if (on_mobile) {
      setTimeout(() => {
        show_description = false;
      }, 3000);
    }
  }
  function handleMouseOut(e) {
    show_description = false;
  }
</script>

<svelte:window bind:innerWidth={width} bind:innerHeight={height} />

<div>
  {#if show_description && loop_playing}
    <div
      id="details"
      class="select-none"
      on:mouseout={handleMouseOut}
      transition:fade
    >
      <h1>{title.toUpperCase()}</h1>
      {#if subtitle != ""}
        <h2>{subtitle.toUpperCase()}</h2>
      {/if}
      <h3>{description}</h3>
    </div>
  {/if}
  {#if !loaded}
    <div class="loader select-none" transition:fade>
      <Jumper size="60" color="white" unit="px" duration="3s" />
      <!-- <div class="spinner-title">Loading from IPFS</div> -->
    </div>
  {/if}
  {#if loaded && !loop_playing}
    <div
      on:click={() => {
        video.play();
        dispatch("click", {});
        loop_playing = true;
      }}
      id="playbox"
      class="select-none"
      transition:fade
    >
      <svg
        version="1.1"
        id="play_button"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 142.448 142.448"
        style="enable-background:new 0 0 142.448 142.448;"
        xml:space="preserve"
      >
        <g>
          <path
            style="fill:#ffff;"
            d="M142.411,68.9C141.216,31.48,110.968,1.233,73.549,0.038c-20.361-0.646-39.41,7.104-53.488,21.639
		C6.527,35.65-0.584,54.071,0.038,73.549c1.194,37.419,31.442,67.667,68.861,68.861c0.779,0.025,1.551,0.037,2.325,0.037
		c19.454,0,37.624-7.698,51.163-21.676C135.921,106.799,143.033,88.377,142.411,68.9z M111.613,110.336
		c-10.688,11.035-25.032,17.112-40.389,17.112c-0.614,0-1.228-0.01-1.847-0.029c-29.532-0.943-53.404-24.815-54.348-54.348
		c-0.491-15.382,5.122-29.928,15.806-40.958c10.688-11.035,25.032-17.112,40.389-17.112c0.614,0,1.228,0.01,1.847,0.029
		c29.532,0.943,53.404,24.815,54.348,54.348C127.91,84.76,122.296,99.306,111.613,110.336z"
          />
          <path
            style="fill:#ffff;"
            d="M94.585,67.086L63.001,44.44c-3.369-2.416-8.059-0.008-8.059,4.138v45.293
		c0,4.146,4.69,6.554,8.059,4.138l31.583-22.647C97.418,73.331,97.418,69.118,94.585,67.086z"
          />
        </g>
      </svg>
    </div>
  {/if}
  <canvas
    class="select-none"
    bind:this={cv}
    on:click={() =>
      dispatch("click", {
        canvas: cv,
        video: video,
      })}
    {width}
    {height}
    on:mouseover={handleMouseOver}
    on:mouseout={handleMouseOut}
  />

  <video
    playsinline
    muted
    loop
    preload="auto"
    bind:duration
    bind:currentTime
    bind:this={video}
  >
    <source src={on_mobile ? src_mobile : src} type="video/mp4" />
  </video>
</div>

<style>
  video {
    visibility: hidden;
    position: fixed;
  }
  canvas {
    touch-action: none;
  }
  h1,
  h2,
  h3 {
    color: rgba(255, 255, 255, 0.85);
  }
  h1 {
    margin: 0;
    padding: 0;
    font-size: 1.85em;
    font-weight: 500;
  }
  h2 {
    margin: 0;
    padding: 0;
    font-size: 1em;
    font-weight: 700;
  }
  h3 {
    margin: 0;
    padding: 0;
    font-size: 0.75em;
    font-weight: 200;
  }
  #details {
    white-space: pre-line;
    position: absolute;
    top: 0;
    left: 0;
    width: 50vw;
    height: calc(100vh - var(--vh-offset, 0px));
    pointer-events: none;
    margin: 30px;
    text-align: left;
    color: white;
    /* display: flex; */
    /* flex-direction: column; */
    /* justify-content: center; */
    /* align-items: center; */
    z-index: 10;
  }
  .select-none {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .loader {
    position: absolute;
    top: 0;
    left: 0;
    display: grid; /* or grid */
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: calc(100vh - var(--vh-offset, 0px));
    /* text-transform: uppercase; */
    font-size: 4em;
    font-weight: 100;
  }
  #play_button {
    width: 25px;
    height: 25px;
  }
  #playbox {
    white-space: pre-line;
    position: absolute;
    display: grid; /* or grid */
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100vw;
    height: calc(100vh - var(--vh-offset, 0px));
    margin: 0px;
    text-align: left;
    color: white;
    /* display: flex; */
    /* flex-direction: column; */
    /* justify-content: center; */
    /* align-items: center; */
    z-index: 10;
  }
</style>
